import { Component, ChangeDetectionStrategy, ViewChild, AfterViewInit } from '@angular/core';
import { StyleRenderer, WithStyles, lyl } from '@alyle/ui';
import { LyDialogRef } from '@alyle/ui/dialog';
import {
  STYLES as CROPPER_STYLES,
  LyImageCropper,
  ImgCropperConfig,
  ImgCropperEvent,
  ImgCropperErrorEvent
} from '@alyle/ui/image-cropper';

const STYLES = () => ({
  cropper: lyl`{
    max-width: 400px
    height: 300px
  }`,
  sliderContainer: lyl`{
    text-align: center
    max-width: 400px
    margin: 14px
  }`
});

@Component({
  selector: 'app-cropper-dialog',
  templateUrl: './cropper-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./cropper-dialog.component.css'],
  providers: [
    StyleRenderer
  ]
})
export class CropperDialogComponent implements WithStyles, AfterViewInit {
  classes = this.sRenderer.renderSheet(STYLES,);
  ready: boolean;
  scale: number;
  minScale: number;
  @ViewChild(LyImageCropper, { static: true }) cropper: LyImageCropper;

  myConfig: ImgCropperConfig = {
    width: 150, // Default `250`
    height: 150, // Default `200`
    fill: '#ff2997', // Default transparent if type = png else #000
    responsiveArea: true
  };

  constructor(
    readonly sRenderer: StyleRenderer,
    public dialogRef: LyDialogRef,
  ) { }

  ngAfterViewInit() {
    this.dialogRef.afterOpened.subscribe(() => {
    });
  }
  onCropped(e: ImgCropperEvent) {
  }
  onLoaded(e: ImgCropperEvent) {
  }
  onError(e: ImgCropperErrorEvent) {
    this.dialogRef.close();
  }

}
